import React from 'react';

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-inner">
        <p>howthishacks — see how cyberattacks actually work</p>
        <p>{'// built for learning, not for harm'}</p>
      </div>
    </footer>
  );
}
